import type { AcademySearchApiPayload } from '../academySearch.interface'

export function buildEmptyPayload(): AcademySearchApiPayload {
  return { documentation: [], quickStart: [], glossary: [] }
}
